import { Component, Input, EventEmitter, Output } from "@angular/core";
import { WizardSubstep } from "../../../common/wizard/wizard-subtep.interface";
import { AutopilotRule } from "../../../../domain/rule";

@Component({
  selector: "icn-graphics-rule-wizard-step1-substep1",
  templateUrl: "./substep1.html",
  styleUrls: ["./substep1.scss"],
})
export class GraphicsRuleWizardStep1Substep1Component implements WizardSubstep {
  colors = [
    "#512da8",
    "#aa00ff",
    "#e57373",
    "#ffc400",
    "#00bfa5",
    "#1de9b6",
    "#40c4ff",
    "#448aff",
  ];

  @Input()
  rule: AutopilotRule;

  onRuleColorSelected(newColor: number) {
    this.rule.color = newColor;
  }

  canGoNext() {
    return !!this.rule.name;
  }
}
